import { OrgTabInfo } from "../organization/org-tab-info"

export const BusinessUnits=()=>{
    return(
        <div><OrgTabInfo/></div>
    )
}